import helpers from './../../helpers.js'
import moment from 'moment'

export default {

    namespaced:true,

    state: {

        calculate_hypothetic_posts: false,

    },// state

    getters: {

        getAll: (state,getters,rootState,rootGetters) => {
            return rootGetters.getAll('economyposts')
            if( !rootGetters.firebase_arrays.economyposts ) return []
            return rootGetters.firebase_arrays.economyposts
        },

        getOne: (state,getters,rootState,rootGetters) => (key) =>  { for( let item of getters.getAll ) if( item.key === key ) return item },

        // input economyposts HAS to be an array, not keyedObj.
        // TODO: input could be either array or keyedObj, it will convert if need be BUT convert is slow
        getFiltered: (state,getters,rootState,rootGetters) => (filters, economyposts) => 
        {

            var output = []

            if( !filters ) filters = {}
            if( !filters['place_posts_by'] ) filters.place_posts_by = 'invoice_date'

            if( !economyposts ) economyposts = getters.getAll

            if( !economyposts ) return output

            for( let i = 0; i < economyposts.length; i++ ) {

                let economypost = economyposts[i]
                
                if( economypost.archived && !filters.include_archived ) continue

                if( filters.client_key != undefined && filters.client_key != 'undefined' ) {
                    if( filters.client_key != economypost.client_key ) continue
                }
                
                if( filters.project_key != undefined && filters.project_key != 'undefined' ) {
                    if( filters.project_key != economypost.project_key ) continue
                }

                if( filters.project_keys != undefined ) {
                    if( filters.project_keys.indexOf(economypost.project_key) === -1 ) continue
                }

                if( filters.income_only && !economypost.amount_dkk_ex_vat > 0 ) continue
                if( filters.expense_only && !economypost.amount_dkk_ex_vat < 0 ) continue

                if( filters.paid !== undefined ) {
                    if( filters.paid === true && !economypost.paid ) continue
                    if( filters.paid === false && economypost.paid ) continue
                }

                if( filters.invoiced !== undefined ) {
                    if( filters.invoiced === true && !economypost.invoiced ) continue
                    if( filters.invoiced === false && economypost.invoiced ) continue
                }

                if( filters.hypothetic !== undefined ) {
                    if( filters.hypothetic === true && !economypost.hypothetic ) continue
                    if( filters.hypothetic === false && economypost.hypothetic ) continue
                }

                if( filters.date_from_timestamp || filters.date_to_timestamp ) {          
                    if( !economypost.date_timestamp ) economyposts[i].date_timestamp = moment(economypost[filters.place_posts_by],'YYYY-MM-DD').unix()
                    var economypost = economyposts[i]
                    if( economypost.date_timestamp < filters.date_from_timestamp ) continue
                    if( economypost.date_timestamp > filters.date_to_timestamp ) continue          
                }

                economypost.year_no = moment(economypost[filters.place_posts_by],'YYYY-MM-DD').format('YYYY')
                economypost.month_no = parseInt(moment(economypost[filters.place_posts_by],'YYYY-MM-DD').format('M'))

                output.push(economypost)

            }

            // sorting
            output.sort(function(a,b){
              return b.amount_dkk_ex_vat - a.amount_dkk_ex_vat
            })

            return output

        },

        getTotals: (state,getters,rootState,rootGetters) => (economyposts) => 
        {
            var totals = {
                income_total: 0,
                expense_total: 0,
                total: 0,
            }

            for( var i = 0; i < economyposts.length; i++ ){
                var post = economyposts[i]
                var val = parseInt(post.amount_dkk_ex_vat)

                if( post.hypothetic && !state.calculate_hypothetic_posts ) continue
                if( val > 0 ) totals.income_total += val
                if( val < 0 ) totals.expense_total += val                
                totals.total += val
            }
            return totals
        },

        getFilteredAndTotals: (state,getters,rootState,rootGetters) => (filters) => 
        {
            var economyposts = getters.getFiltered(filters)
            var totals = getters.getTotals(economyposts)
            return {
                posts: economyposts,
                totals: totals,
            }
        },

        
    },// getters

    mutations:{

        toggle_calculate_hypothetic_posts(state)
        {
            var val = !state.calculate_hypothetic_posts
            state.calculate_hypothetic_posts = val
        },
        
    },

}


// WEBPACK FOOTER //
// ./src/store/modules/economyposts.js